const getters = {
    token: (state) => state.user.token,
    departmentName: (state) => state.user.departmentName,
    jdlbTypeId: (state) => state.declare.jdlbTypeId,
    jdlbTypeName: (state) => state.declare.jdlbTypeName,
    reportTaskInfo: (state) => state.declare.reportTaskInfo,
    comInfo: (state) => state.declare.comInfo,
    declareStepStatus: (state) => state.declare.declareStepStatus,
    nowStepStatus: (state) => state.declare.nowStepStatus
};
export default getters;
